import { TranscriptSkeletonRow } from './transcript-skeleton/transcript-skeleton-row';

export function TranscriptSkeleton() {
    return (
        <div className="pb-6 grid grid-cols-[1.5rem_1fr] gap-x-4 gap-y-6">
            {Array.from({ length: 4 }).map((_, i) => (
                <TranscriptSkeletonRow key={i} />
            ))}
        </div>
    );
}
